import { Component, Input, OnInit } from '@angular/core';
import { Observable, Observer, Subscription } from 'rxjs';

@Component({
    selector: '[spinner]',
  templateUrl: 'spinner.component.html'
})

export class SpinnerComponent implements OnInit {

  @Input() show: boolean;
  @Input() disable: boolean;
//  private element: any = null;
public enableObservable: Observable < boolean > ;
private subscription: Subscription = null;
private enableObserver: Observer < boolean > ;
  constructor() {
//    this.element = spinnerElement.nativeElement;
  }
  // DANNI DA RISOLVERE
  ngOnInit() {
    // this.createServiceSubscription();
  }

    // private createServiceSubscription() {
    //   this.enableObservable = new Observable < boolean > (observer => {
    //     this.enableObserver = observer;
    //     if (this.enableObserver) {
    //       this.startSpinner();
    //     } else {
    //       this.stopSpinner();
    //     }
    //   });
    // }

  startSpinner() {
    this.show = true;
  }

  stopSpinner() {
    this.show = false;
  }

}
